import numeral from 'numeral'

const oppSide = side => side === 'width' ? 'height' : 'width'

const resizeDimensions = dimensions => {
  const { width, height } = dimensions
  if (!width && !height) return
  const key = width > height ? 'width' : 'height'
  let side = dimensions[key]

  while (side > 5000) {
    side = side * 0.3
  }

  const ratio = side / dimensions[key]
  const otherSide = dimensions[oppSide(key)] * ratio

  return {
    [key]: numeral(side.toFixed()).format('0,0'),
    [oppSide(key)]: numeral(otherSide.toFixed()).format('0,0')
  }
}

export default resizeDimensions



// WEBPACK FOOTER //
// ./src/components/FloorPlanUploader/FileInfo/resizeDimensions.js